import { ClassAttributes } from 'react';
//import { useReactiveVar } from '@apollo/client';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as HistoryConsumer } from '../context/history';
import { Consumer as StateConsumer } from '../context/state';
import _FatalErrorScreen from '../screen/FatalErrorScreen';
//import { errorsVar } from '../../cache';
//import globalState from '../../operations/commands';
//import { FatalError } from '../../operations/commands/Errors/setErrors';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const FatalErrorScreen = ({ className }: Props) => {
  //const errors = useReactiveVar(errorsVar)?.sort(e => e instanceof FatalError ? -1 : 0);
  //const fatallyErrored = errors?.some(error => error instanceof FatalError);

  return (
    <DependencyConsumer>
      {(dependency) => (
        <HistoryConsumer>
          {(history) => (
            <StateConsumer>
              {
                (state) =>
                  state.fatalError ? (
                    <_FatalErrorScreen
                      error={state.fatalError.error}
                      solveTo={state.fatalError.solveTo}
                      onClickBackButton={(_: any, solveTo: string) => {
                        history.push(solveTo);
                        dependency.errorPresenter.resolveFatal();
                      }}
                      className={className}
                      pathname={state.location.pathname}
                    />
                  ) : null /*fatallyErrored ? (
                  <_FatalErrorScreen
                    error={errors![0]}
                    solveTo={'/'}
                    onClickBackButton={(_: any, solveTo: string) => {
                      history.push(solveTo);
                      globalState.disposeErrors();
                    }}
                    className={className}
                    pathname={state.location.pathname}
                  />                
                ) : null*/
              }
            </StateConsumer>
          )}
        </HistoryConsumer>
      )}
    </DependencyConsumer>
  );
};

export default FatalErrorScreen;
